import React from "react";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import { TextField } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { Cart } from "./../../";

function Field({
	field_key,
	form,
	type,
	input,
	label,
	required,
	options,
	multiple,
	disabled,
}) {
	let value = form.values ? form.values[field_key] : null;
	if (multiple && !value) {
		value = [];
	}
	const error =
		form.touched[field_key] && typeof form.errors[field_key] !== "undefined";
	const helperText = error ? form.errors[field_key] : null;

	if (input === "select" && multiple) {
		return (
			<FormControl component="fieldset" variant="standard">
				<FormLabel component="legend">{`${label} ${
					required ? "*" : ""
				}`}</FormLabel>
				<FormGroup>
					{options.map((option) => {
						const checked =
							form.values && Array.isArray(form.values[field_key])
								? form.values[field_key].indexOf(option.value) > -1
								: false;
						return (
							<FormControlLabel
								key={`${field_key}-${option.value}}`}
								control={
									<Checkbox
										disabled={form.isSubmitting || disabled}
										checked={checked}
										onChange={form.handleChange}
										id={field_key}
										name={field_key}
										value={option.value}
									/>
								}
								label={option.label}
							/>
						);
					})}
				</FormGroup>
				{helperText && <FormHelperText error>{helperText}</FormHelperText>}
			</FormControl>
		);
	} else if (input === "select") {
		return (
			<TextField
				fullWidth
				select
				name={field_key}
				id={field_key}
				label={`${label} ${required ? "*" : ""}`}
				SelectProps={{
					native: true,
				}}
				onChange={form.handleChange}
				disabled={form.isSubmitting || disabled}
				value={value}
				error={error}
				helperText={helperText}
			>
				<option aria-label="None" value="" />
				{options.map((option) => (
					<option key={option.value} value={option.value}>
						{option.label}
					</option>
				))}
			</TextField>
		);
	} else if (input === "radio") {
		return (
			<FormControl error={error}>
				<FormLabel id={field_key}>{`${label} ${
					required ? "*" : ""
				}`}</FormLabel>
				<RadioGroup
					row={options.length === 2}
					aria-labelledby={field_key}
					name={field_key}
					value={value}
					onChange={(event) => {
						form.setFieldValue(field_key, event.currentTarget.value);
					}}
				>
					{options.map((option) => (
						<FormControlLabel
							key={option.value}
							value={option.value}
							control={<Radio checked={value === option.value} />}
							label={option.label}
						/>
					))}
				</RadioGroup>
				{helperText && <FormHelperText error>{helperText}</FormHelperText>}
			</FormControl>
		);
	} else if (input === "cart") {
		return <Cart form={form} />;
	} else {
		let InputLabelProps = {
			shrink: (type !== "text" && type !== "number") || value,
		};
		return (
			<TextField
				fullWidth
				name={field_key}
				id={field_key}
				label={`${label} ${required ? "*" : ""}`}
				type={type}
				onChange={form.handleChange}
				disabled={form.isSubmitting || disabled}
				value={value}
				error={error}
				helperText={helperText}
				multiline={input === "textarea"}
				InputLabelProps={InputLabelProps}
			/>
		);
	}
}

export default Field;
